import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-dialog-alert-location',
  templateUrl: './alert-location.component.html',
  styleUrls: ['./alert-location.component.scss'],
})
export class AlertLocationComponent implements OnInit {
  labels: any;
  isAlertOpen: boolean = false;

  public isMobileSize: boolean;
  isMobile$: Observable<boolean>;
  private _displayMobile: boolean = true;
  public get displayMobile() {
    return this._displayMobile;
  }

  constructor(
    private _mobileBreakPoinntService: MobileBreakPointsService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) // private dialogRef: MatDialogRef<AlertLocationComponent>
  {
    this.isMobile$ = this._mobileBreakPoinntService.mobileBreakPoints$;
  }

  ngOnInit(): void {
    this.labels = this.dialogData.labels;
    this.isAlertOpen = this.dialogData.isAlertOpen;
    this.isMobile$.subscribe((value) => {
      this.isMobileSize = value;
    });
  }

  onClose() {
    const delay = this.isMobileSize ? 200 : 0;
    setTimeout(() => {
      // this.dialogRef.close();
      this.dialogData.closeAlert();
    }, delay);
  }
}
